import { Controller } from "@hotwired/stimulus"

// Enter submits the note; Shift+Enter inserts a newline. Also exposes submit()
// for blur-to-save fields (e.g. group labels).
export default class extends Controller {
  maybeSubmit(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.element.form?.requestSubmit()
    }
  }

  submit() {
    this.element.form?.requestSubmit()
  }
}
